import { z } from "zod";

export const ProjectKind = z.enum(["shared", "personal"]);
export type ProjectKind = z.infer<typeof ProjectKind>;

export const ProjectSchema = z
  .object({
    id: z.uuid(),
    slug: z.string().min(1).max(80),
    name: z.string().min(1).max(200),
    kind: ProjectKind,
    ownerId: z.uuid().nullable(),
    createdAt: z.iso.datetime(),
  })
  .refine((data) => data.kind !== "personal" || data.ownerId !== null, {
    message: "Un projet personal doit avoir un ownerId",
    path: ["ownerId"],
  });

export type Project = z.infer<typeof ProjectSchema>;

export function parseProject(input: unknown): Project {
  return ProjectSchema.parse(input);
}

// Libellé d'affichage d'un projet. Le projet personnel est stocké en base sous
// « Personnel — <partie locale du courriel> » ; à l'écran, chacun ne voit que
// SON propre projet perso (RLS), donc « Personnel » seul suffit et reste sans
// ambiguïté — on masque la partie courriel. Les projets partagés gardent leur
// nom tel quel.
export function projectDisplayName(p: Project): string {
  return p.kind === "personal" ? "Personnel" : p.name;
}
